import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import {
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';





export const getAllAnalytics = createAsyncThunk('analytics/getAll', async (info, thunkAPI) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.BASE_URL}/work/all`, {
            limit: 100,
            page: 1
        });
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
export const getProfileById = createAsyncThunk('profile/getAdById', async (id, thunkAPI) => {
    try {
        console.log('getProfileById thunk - Calling API with ID:', id);
        const response = await api.get(`/profile/${id}`);
        console.log('getProfileById thunk - API response:', response);
        return response.data;
    } catch (error) {
        console.error('getProfileById thunk - API error:', error);
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
});


export const getPublicProfileById = createAsyncThunk('profile/getAdById', async (id, thunkAPI) => {
    try {
        const response = await api.get(`/profile/pub/${id}`);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
});

// export const getSingleAdAnalytics = createAsyncThunk(
//     '/dev/v1/analytics/get',
//     async ({ type, adId }, thunkAPI) => {
//         try {
//             const response = await api.get(`/dev/v1/analytics/get?type=${type}&ad_id=${adId}`);
//             return response.data;
//         } catch (error) {
//             return thunkAPI.rejectWithValue(error.response.data);
//         }
//     }
// );

export const getSingleAdAnalytics = createAsyncThunk(
    'analytics/getSingle',
    async ({
        type,
        adId,
        limit,
        page
    }, thunkAPI) => {
        try {
            const response = await api.get(API_ENDPOINTS.ANALYTICS.GET, {
                limit,
                page
            });
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);